import * as React from 'react';
import { Flat } from './Flat';
import * as styles from './flatsList.css';
import { UIHeading1, UIText2 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FlatsList = function FlatsList(_ref) {
  var flats = _ref.flats,
    hoveredFlatPlanId = _ref.hoveredFlatPlanId,
    onFlatHover = _ref.onFlatHover,
    floorNumber = _ref.floorNumber,
    flatCountLabel = _ref.flatCountLabel;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['list'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['header'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(UIHeading1, {
          children: floorNumber
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['description'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          children: flatCountLabel
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['flats'],
      children: flats.map(function (flat) {
        return /*#__PURE__*/_jsx(Flat, {
          id: flat.id,
          url: flat.offer.url,
          booked: flat.booked,
          hasDecoration: flat.hasDecoration,
          hoveredFlatPlanId: hoveredFlatPlanId,
          onFlatHover: onFlatHover,
          img: flat.flatPlanPreviewUrl,
          price: flat.price,
          title: flat.title
        }, flat.id);
      })
    })]
  });
};